import React from 'react';
import styled from 'styled-components'
import Header from '../../components/header'

const Container = styled.div`
    height: 100%;
`

export default class Home extends React.Component {

    render() {

        return (
            <Container>
                <Header />
            </Container >
        )
    }
}